import { pagingButtonFunc } from './functions/pagingButtons';
import { filterModalCategory, filterModalGenre } from './functions/filterModalButtons';

// ロード後に実行
document.addEventListener('DOMContentLoaded', () => {
  // ページングボタンにそれぞれonclickを登録
  pagingButtonFunc(onChangePage);
  // 絞り込みモーダルカテゴリ
  filterModalCategory(onChangeModalCategory);

  // カテゴリタブ押下時の動作登録
  const categoryTab = document.getElementsByName('reservation-category');
  categoryTab.forEach((ele) => {
    ele.addEventListener('change', () => {
      // 検索フォームをクリア
      const form = document.forms.search_form;
      form.removeChild(form.querySelector('input[name=cat]'));

      // カテゴリ指定で再検索
      addHiddenInput(form, 'cat', ele.value);
      // ページング、カテゴリ、ジャンル、mrack、srack以外のパラメータを引き継ぐ
      Object.entries(condition)
        .filter(
          ([key, value]) =>
            !key.startsWith('cl') &&
            !key.startsWith('page') &&
            !key.startsWith('cat') &&
            !key.startsWith('genre') &&
            !key.startsWith('mrack') &&
            !key.startsWith('srack') &&
            !key.startsWith('filter_category') &&
            !key.startsWith('filter_genre') &&
            !key.startsWith('filter_size') &&
            !key.startsWith('filter_artist') &&
            !key.startsWith('cname'),
        )
        .forEach(([key, value]) => addHiddenInput(form, key, value));

      form.submit();
    });
  });

  // サイドバー カテゴリのhref設定
  const sidebarLinks = document.querySelectorAll('.js-sidebar-link');
  sidebarLinks.forEach((ele) => {
    const tmpCondition = { ...condition };
    if (ele.dataset.value.includes('-')) {
      const codes = ele.dataset.value.split('-');
      if (codes.length === 2) {
        tmpCondition.cat = codes[0];
        tmpCondition.genre = codes[1];
        delete tmpCondition.mrack;
        delete tmpCondition.srack;
      }
      if (codes.length === 3) {
        tmpCondition.cat = codes[0];
        tmpCondition.genre = codes[1];
        tmpCondition.mrack = codes[2];
        delete tmpCondition.srack;
      }
      if (codes.length === 4) {
        tmpCondition.cat = codes[0];
        tmpCondition.genre = codes[1];
        tmpCondition.mrack = codes[2];
        tmpCondition.srack = codes[3];
      }
    } else {
      tmpCondition.cat = ele.dataset.value;
      delete tmpCondition.genre;
      delete tmpCondition.mrack;
      delete tmpCondition.srack;
    }
    delete tmpCondition.filter_category;
    delete tmpCondition.filter_genre;

    const params = Object.entries(tmpCondition)
      .filter(([key, value]) => !key.startsWith('cl') && !key.startsWith('page'))
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    ele.href = `${ele.dataset.baseurl}?${params}`;
  });

  const sidebarSearchButton = document.querySelectorAll('.js-sidebar-search');
  sidebarSearchButton.forEach((ele) => {
    ele.addEventListener('click', () => {
      // まず関係する条件を初期化
      delete condition.pricef;
      delete condition.pricet;
      delete condition.issuef;
      delete condition.issuet;
      delete condition.deepdiscount;
      delete condition.pricecut;
      delete condition.deliveryclass;
      delete condition.freebook;
      delete condition.facet;

      // facetを成形
      document.querySelectorAll(`input:checked[data-key="facet"]`)?.forEach((sideFacet) => {
        if (sideFacet.dataset.ftflg) {
          condition[sideFacet.dataset.ftflg] = sideFacet.value;
        } else {
          condition.facet = appendFacetString(sideFacet.value);
          // condition[sideFacet.value] = '1';
        }
      });
      condition.facet = encodeURIComponent(condition.facet);

      // recommendを成形
      document.querySelectorAll(`input:checked[data-key="recommend"]`)?.forEach((sideRecom) => {
        condition[sideRecom.value] = '1';
      });

      // 価格帯
      // テキストボックスはpricef、pricetなので別枠
      const priceMin = document.querySelector(`input[name=price-min-range]`).value;
      const priceMax = document.querySelector(`input[name=price-max-range]`).value;
      if (priceMin !== '' && priceMax !== '' && !isNaN(priceMin) && !isNaN(priceMax)) {
        condition.pricef = priceMin;
        condition.pricet = priceMax;
      } else if (priceMin !== '' && !isNaN(priceMin)) {
        condition.pricef = priceMin;
      } else if (priceMax !== '' && !isNaN(priceMax)) {
        condition.pricet = priceMax;
      }
      // 発行年
      // テキストボックスはissuef、issuetなので別枠
      const yearMin = document.querySelector(`input[name=year-min-range]`).value;
      const yearMax = document.querySelector(`input[name=year-max-range]`).value;
      if (yearMin !== '' && yearMax !== '' && !isNaN(yearMin) && !isNaN(yearMax)) {
        condition.issuef = yearMin;
        condition.issuet = yearMax;
      } else if (yearMin !== '' && !isNaN(yearMin)) {
        condition.issuef = yearMin;
      } else if (yearMax !== '' && !isNaN(yearMax)) {
        condition.issuet = yearMax;
      }

      // 一意に決定する系
      ['author', 'size', 'stock', 'freebook'].forEach((attr) => {
        condition[attr] = document.querySelector(`input:checked[data-key="${attr}"]`)?.value || '';
      });

      const params = Object.entries(condition)
        .filter(([key, value]) => !key.startsWith('cl') && !key.startsWith('page')) // ページは先頭から
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      location.href = location.pathname + '?' + params;
    });
  });
  // サイドバークリア：金額 テキストもクリア
  const sidebarPriceClear = document.querySelector('.js-clearSidePrice');
  sidebarPriceClear.addEventListener('click', () => {
    document.querySelector(`input[name=price-min-range]`).value = '';
    document.querySelector(`input[name=price-max-range]`).value = '';
  });

  // サイドバークリア：発行年 テキストもクリア
  const sidebarYearClear = document.querySelector('.js-clearSideYear');
  sidebarYearClear.addEventListener('click', () => {
    document.querySelector(`input[name=year-min-range]`).value = '';
    document.querySelector(`input[name=year-max-range]`).value = '';
  });

  // 絞り込みモーダル条件リセットボタン
  const searchClearButton = document.querySelectorAll('.js-clearFilterTabForm');
  searchClearButton.forEach((ele) => {
    ele.addEventListener('click', () => {
      const parent = ele.closest('form');
      parent.reset();
      document.querySelectorAll('input[name=filter_category]').forEach((ele) => {
        ele.checked = false;
      });
      parent.filter_price_min.value = '';
      parent.filter_price_max.value = '';
      const genreList = parent.querySelector('.js-filter-list-genre');
      const artistList = parent.querySelector('.js-filter-list-artist');
      genreList.innerHTML = '';
      artistList.innerHTML = '';
      genreList.insertAdjacentHTML('beforeend', '<p>カテゴリを選択してください。</p>');
      artistList.insertAdjacentHTML('beforeend', '<p>カテゴリを選択してください。</p>');
    });
  });
});

// ページングボタン押下時に該当ページの検索を行う
function onChangePage(page) {
  // 検索フォームをクリア
  const form = document.forms.search_form;
  form.textContent = '';

  // clの値を計算
  condition.cl = (page - 1) * condition.dnum;
  const entries = Object.entries(condition);

  // 前回検索値を引継ぎ
  for (const [condName, condValue] of entries) {
    addHiddenInput(form, condName, condValue);
  }
  form.submit();
}

// フォームにhiddenを持たせる
function addHiddenInput(form, name, value) {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.setAttribute('name', name);
  input.setAttribute('value', value);
  form.appendChild(input);
}

/**
 * 検索条件：facetの文字列を成形する
 * @param {string} facetStr
 * @returns string 成形済みのfacet
 */
function appendFacetString(facetStr = '') {
  // facetが未指定か空文字の場合、そのままFACETとして使用
  if (!condition.facet) {
    return facetStr;
  }
  // ||で連結なしの場合
  if (!condition.facet.includes('||')) {
    return `${condition.facet}||${facetStr}`;
  }
  // ||で連結ありの場合
  // facet=deliveryclass:1||price:1 ~ 1000 ←を成形する、キーが重複したら上書き
  let isDupKey = false;
  const newFacetStr = condition.facet
    .split('||')
    .map((facetCond) => {
      const [facetKey, facetValue] = facetCond.split(':');
      const [facetStrKey, facetStrValue] = facetStr.split(':');
      // キーが重複した場合、新しいのを優先
      if (facetKey === facetStrKey) {
        isDupKey = true;
        return facetStr;
      }
      return facetCond;
    })
    .join('||');
  return isDupKey ? newFacetStr : `${condition.facet}||${facetStr}`;
}

// 絞り込みモーダル：カテゴリ押下時
function onChangeModalCategory(element) {
  const catButtons = document.querySelectorAll('.js-filter-modal-category');
  const searchClearButton = document.querySelectorAll('.js-clearFilterTabForm');

  // 非活性化
  catButtons.forEach((ele) => (ele.disabled = true));
  searchClearButton.forEach((ele) => (ele.disabled = true));

  const parent = element.closest('form');
  // 検索API実行
  fetch(`/api/cmdtysearch/?cat=${element.value}&word=${encodeURIComponent(condition.word)}${condition.saleid ? `&saleid=${condition.saleid}` : ''}`)
    .then((data) => data.json())
    .then((res) => {
      const genreList = parent.querySelector('.js-filter-list-genre');
      const artistList = parent.querySelector('.js-filter-list-artist');
      genreList.innerHTML = '';
      artistList.innerHTML = '';
      // 結果がなければ─を表示
      if (!res.condSummary.facet_ctgry_lrack) {
        genreList.insertAdjacentHTML('beforeend', '<p>－</p>');
        artistList.insertAdjacentHTML('beforeend', '<p>－</p>');
        return;
      }
      // モーダルのジャンルを成形
      res.condSummary.facet_ctgry_lrack.forEach((item, index) => {
        genreList.insertAdjacentHTML(
          'beforeend',
          `
          <li class="l-filter-tab__list--item">
            <input
              type="radio"
              id="filter_genre_${index}"
              name="filter_genre"
              class="c-checkbox__tag js-filter-modal-genre"
              value="${item.value}"
              ${item.checked && item.checked === 'true' ? 'checked' : ''}
            />
            <label for="filter_genre_${index}" class="c-checkbox__label--tag">${item.text}</label>
          </li>
        `,
        );
      });
      // モーダルの著者・アーティストを成形
      res.condSummary.facet_author.forEach((item, index) => {
        artistList.insertAdjacentHTML(
          'beforeend',
          `
            <li class="l-filter-tab__list--item">
              <input type="radio" id="filter_artist_${index}" name="filter_artist" class="c-checkbox__tag" value="${item.value}"
                ${item.checked && item.checked === 'true' ? 'checked' : ''} />
              <label for="filter_artist_${index}" class="c-checkbox__label--tag">${item.text}</label>
            </li>
          `,
        );
      });
      filterModalGenre(onChangeModalGenre);
    })
    .catch((reason) => {
      console.log(reason);
    })
    .finally(() => {
      // 活性化
      catButtons.forEach((ele) => (ele.disabled = false));
      searchClearButton.forEach((ele) => (ele.disabled = false));
    });
}

// 絞り込みモーダル：ジャンル押下時
function onChangeModalGenre(element) {
  const catButtons = document.querySelectorAll('.js-filter-modal-category');
  const genreButtons = document.querySelectorAll('.js-filter-modal-genre');
  const searchClearButton = document.querySelectorAll('.js-clearFilterTabForm');

  // 非活性化
  catButtons.forEach((ele) => (ele.disabled = true));
  genreButtons.forEach((ele) => (ele.disabled = true));
  searchClearButton.forEach((ele) => (ele.disabled = true));

  const parent = element.closest('form');
  const [catValue, genreValue] = element.value.split('_');
  // 検索API実行
  fetch(`/api/cmdtysearch/?cat=${catValue}&word=${encodeURIComponent(condition.word)}&genre=${genreValue}`)
    .then((data) => data.json())
    .then((res) => {
      const artistList = parent.querySelector('.js-filter-list-artist');
      artistList.innerHTML = '';
      // モーダルのジャンルを成形
      if (!res.condSummary.facet_ctgry_lrack) {
        artistList.insertAdjacentHTML('beforeend', '<p>－</p>');
        return;
      }
      res.condSummary.facet_author.forEach((item, index) => {
        artistList.insertAdjacentHTML(
          'beforeend',
          `
            <li class="l-filter-tab__list--item">
              <input type="radio" id="filter_artist_${index}" name="filter_artist" class="c-checkbox__tag" value="${item.value}"
                ${item.checked && item.checked === 'true' ? 'checked' : ''} />
              <label for="filter_artist_${index}" class="c-checkbox__label--tag">${item.text}</label>
            </li>
          `,
        );
      });
    })
    .catch((reason) => {
      console.log(reason);
    })
    .finally(() => {
      // 活性化
      catButtons.forEach((ele) => (ele.disabled = false));
      genreButtons.forEach((ele) => (ele.disabled = false));
      searchClearButton.forEach((ele) => (ele.disabled = false));
    });
}
